import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import heroImg from "../TestImages/StockCake-Serene_Workspace_Sanctuary-2089290-standard.jpg";
import "./Explore.css";
// import heroImg from "../TestImages/TestStediBackground2.webp";

// ADD the learn more buttons, link to basic/pro how to's

//IDEA FOR MOBILE, HAVE THESE COLLASPSIBLE AND OPEN ON TAP
//OR HAVE EACH SECTION COLLAPSIBLE, IDK

function Explore() {
  return (
    <div>
      {/* styling for this hero coming from OurMission.css file */}
      <div className="hero pt-4">
          <div
            className="hero-bg"
            style={{ backgroundImage: `url(${heroImg})` }}
          />
        <div className="hero-overlay" />
        <Container className="hero-inner pt-5">
          <h1 className="hero-title">Explore the App</h1>
          <p className="hero-subtitle">
            Basic and Pro+ Tier Features
          </p>
        </Container>
      </div>
      <Container className="mt-3 pb-1">
        <Row className="row-spacing g-4">
          <Col md>
              <div className="card-shell">
                <div className="card-hero">
                  <span className="badge basic-badge"> Business Manager </span>
                  <span className="card-price"> $5.99/mo</span>
                </div>

                <div className="card-content">
                  <h6 className="list-header"> Prospect and Customer Management</h6>
                  <ul>
                    <li>
                      Categorize your Prospect
                    </li>
                    <li>
                      Select product/service interests
                    </li>
                    <li>
                      View details, status, actions, notes, and set reminders
                    </li>
                  </ul>

                  <h6 className="list-header">Resources</h6>
                  <ul>
                    <li>
                      Training, information, graphics, and tools all organized in easily accessible folders
                    </li>
                  </ul>

                  <h6 className="list-header">Events</h6>
                  <ul>
                    <li>
                      Add events, meetings, and live trainings that sync with your Apple calendar
                    </li>
                  </ul>

                  <h6 className="list-header">Dashboard</h6>
                  <ul>
                    <li>
                      Customizable dashboard that can change with any new announcements or updates from your team leader
                    </li>
                  </ul>
                </div>
              </div>
          </Col>

          <Col md>
            <div className="card-shell">
              <div className="card-hero">
                <span className="badge pro-badge"> Team Manager + </span>
                <span className="card-price"> $12.99/mo</span>
              </div>


              <div className="card-content">
                <span className="basic-tag"> All Basic features + </span>

                <h6 className="list-header"> Onboarding and Training System </h6>
                <ul>
                  <li>
                    Create simple steps to onboard new team members
                  </li>
                  <li>
                    Track team members' progress through "actions" that you set
                  </li>
                  <li>
                    Link Resource boards for quick access to important trainings, links, graphics, and documents
                  </li>
                </ul>

                <h6 className="list-header">Team Tracking</h6>
                <ul>
                  <li>
                    Set goals for your team and track their progress. Get a pulse on where you should focus your leadership efforts each month
                  </li>
                  <li>
                    View detailed team analytics to monitor performance trends and identify opportunities for growth
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>

  );
}

export default Explore;

